import React, { useEffect } from 'react';

export default function ConfirmModal({ message, detail, confirmLabel = 'Delete', onConfirm, onCancel }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onCancel(); if (e.key === 'Enter') onConfirm(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onConfirm, onCancel]);

  return (
    <div style={s.overlay} onClick={onCancel}>
      <div style={s.modal} onClick={e => e.stopPropagation()}>
        <div style={s.iconWrap}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        </div>
        <div style={s.message}>{message}</div>
        {detail && <div style={s.detail}>{detail}</div>}
        <div style={s.actions}>
          <button style={s.cancelBtn} onClick={onCancel}>Cancel</button>
          <button style={s.confirmBtn} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}

const s = {
  overlay:    { position:'fixed', inset:0, background:'rgba(15,23,42,0.45)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 },
  modal:      { background:'#fff', border:'1px solid #e2e8f0', borderRadius:20, padding:'28px 32px', width:360, maxWidth:'90vw', boxShadow:'0 20px 60px rgba(15,23,42,0.18)', textAlign:'center' },
  iconWrap:   { width:48, height:48, background:'#fef2f2', border:'1px solid #fecaca', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px' },
  message:    { fontSize:16, fontWeight:700, color:'#0f172a', marginBottom:8 },
  detail:     { fontSize:13, color:'#64748b', marginBottom:16, lineHeight:1.5 },
  actions:    { display:'flex', gap:10, marginTop:20 },
  cancelBtn:  { flex:1, background:'#f1f5f9', border:'1px solid #e2e8f0', borderRadius:10, padding:'11px', fontSize:14, fontWeight:600, cursor:'pointer', color:'#475569' },
  confirmBtn: { flex:1, background:'#dc2626', border:'none', borderRadius:10, padding:'11px', fontSize:14, fontWeight:700, cursor:'pointer', color:'#fff' },
};
